import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TikTokOutlinedSvg from "@ant-design/icons-svg/es/asn/TikTokOutlined";
import AntdIcon from "../components/AntdIcon";
var TikTokOutlined = function TikTokOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TikTokOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TikTokOutlined.displayName = 'TikTokOutlined';
}
export default /*#__PURE__*/React.forwardRef(TikTokOutlined);